import { ListItemStringValueSchema } from 'model';
import { ManfreditesStats } from 'model/manfredites-stats/model.manfredites-stats';
import { z } from 'zod';
import { YourOfferSalaryPageProps } from '../YourOfferSalaryPage.types';

export type YourOfferSalaryFormProps = Pick<
  YourOfferSalaryPageProps,
  'roles' | 'techs' | 'yearsOfExperience'
> & {
  onSuccess: (data: ManfreditesStats, experienceRange: string) => void;
};

export const YourOfferSalaryFormFieldsSchema = z.object({
  role: ListItemStringValueSchema,
  yearsOfExperience: ListItemStringValueSchema,
  techs: z
    .array(ListItemStringValueSchema)
    .max(2, 'your-offer-salary:your-offer-salary.messages.max-techs')
    .min(1, 'your-offer-salary:your-offer-salary.messages.min-techs'),
  withFluentEnglish: z.boolean(),
  isRemote: z.boolean(),
  location: ListItemStringValueSchema.optional()
});

export type YourOfferSalaryFormFields = z.infer<
  typeof YourOfferSalaryFormFieldsSchema
>;
